// Tab navigation: replaces WB.loadTabArea's $("#WFarea").load("/tab?index=N").
//
// A tab is one entry of session.ui.tabs (index, slug, title, tpl, proc). Its body
// comes from the client-side registry when the tpl has been converted, otherwise
// from the legacy /tab route until it is (wb repo, docs/SPA-PLAN.md). Either way the tab's
// proc (WB.shipping.showShipping, ...) then runs exactly as before.
import { render } from './tpl.js';
import { navigate } from './router.js';
import { tabViews, PROCS_LOGGING_THEIR_VISIT } from '../views/index.js';

let tabs = [];
let current = null;

export function setTabs(list) {
  tabs = list || [];
}

export function allTabs() {
  return tabs;
}

export function bySlug(slug) {
  return tabs.find((t) => t.slug === slug) || null;
}

export function byIndex(index) {
  return tabs.find((t) => String(t.index) === String(index)) || null;
}

export function defaultTab() {
  return tabs[0] || null;
}

export function currentTab() {
  return current;
}

export function pathFor(tab) {
  return '/tabs/' + tab.slug;
}

// Draw the <li> entries into the shell's nav (before the responsive "More" item).
export function renderNav() {
  const ul = document.getElementById('main');
  if (!ul) return;
  const more = document.getElementById('displayMoreList');
  for (const li of Array.from(ul.querySelectorAll('li:not(.more)'))) li.remove();
  for (const tab of tabs) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = pathFor(tab);
    a.className = 'wb-nav-link';
    a.id = 'wb-nav-item-' + tab.index;
    a.textContent = tab.title;
    // Single owner of the click: the legacy delegated handler on .wb-nav-tabs
    // (WB.initEvents) would otherwise also call WB.loadTabArea and load twice.
    // Clones in the responsive "More" menu lose this listener and fall through to
    // that legacy handler, which reaches the router via the loadTabArea hook.
    a.addEventListener('click', (e) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      e.stopPropagation();
      navigate(pathFor(tab));
    });
    li.appendChild(a);
    ul.insertBefore(li, more);
  }
}

function markActive(tab) {
  const WB = window.WB;
  window.$('.wb-nav-tabs li').removeClass('active');
  const link = document.getElementById('wb-nav-item-' + tab.index);
  if (link && link.parentElement) link.parentElement.classList.add('active');
  if (WB && WB.makeNavigationMenuResponsive) {
    // the "More" overflow menu clones links; keep its active state in step
    window.$('#moreList li').removeClass('active');
    window.$('#moreList a[id="wb-nav-item-' + tab.index + '"]').parent().addClass('active');
  }
}

function afterBodyLoaded(tab, clientRendered) {
  const WB = window.WB;
  // a workflow-style fragment may have pushed a state (legacy /start, /next)
  if (window.WBstate) {
    const state = window.WBstate;
    window.WBstate = false;
    WB.workflowCtl.pushState(state);
  }
  if (clientRendered && tab.proc && !PROCS_LOGGING_THEIR_VISIT.has(tab.proc)) {
    // the visit log the server-rendered /tab used to write
    window.$.post('domenu', { menuitem: tab.englishTitle || tab.title });
  }
  if (typeof tab.proc === 'string' && tab.proc) {
    WB.callNamedProcedure(tab.proc);
  }
}

export function show(tab) {
  const WB = window.WB;
  const $ = window.$;
  if (!tab) return;
  current = tab;
  markActive(tab);
  // what WB.loadTabArea cleared before loading a tab
  $('#wbformtarget').html('');
  $('.showHideSideBarDiv').remove();

  const html = tabViews[tab.tpl];
  const area = document.getElementById('WFarea');
  if (html !== undefined) {
    area.innerHTML = render(html, WB.session || {});
    afterBodyLoaded(tab, true);
  } else {
    // not converted yet: the legacy server-rendered fragment
    $(area).load('/tab?index=' + encodeURIComponent(tab.index), function (text, status, xhr) {
      if (status === 'error') {
        area.innerHTML = '<div class="alert alert-danger">' + xhr.status + ' ' + xhr.statusText + '</div>';
        return;
      }
      afterBodyLoaded(tab, false);
    });
  }
}

export function showSlug(slug) {
  const tab = bySlug(slug);
  if (!tab) {
    const d = defaultTab();
    if (d) navigate(pathFor(d), { replace: true });
    return;
  }
  show(tab);
}

// Wire the legacy entry points onto the router so old callers keep working:
//   WB.loadTabArea(index)  (nav clicks in WB.initEvents, WB.openLiveInventoryTab, ...)
//   WB.enableNavTabs()     (WB.initUIConfig at the end of the login sequence)
export function installLegacyHooks(WB) {
  WB.loadTabArea = function (index) {
    if (typeof index === 'undefined' || index === -1) {
      const d = defaultTab();
      if (d) navigate(pathFor(d));
      return;
    }
    if (typeof index === 'string' && index.indexOf('?') >= 0) {
      // a raw content url (workflow flows); keep the old behaviour
      window.$('#WFarea').load(index);
      return;
    }
    const tab = byIndex(index);
    if (tab) navigate(pathFor(tab));
  };
  WB.enableNavTabs = function () {
    window.$('.nav li').removeClass('disabled');
    const path = window.location.pathname;
    const m = path.match(/^\/tabs\/([^/]+)$/);
    if (m && bySlug(m[1])) {
      show(bySlug(m[1]));
    } else {
      const d = defaultTab();
      if (d) navigate(pathFor(d), { replace: true });
    }
  };
  WB.disableNavTabs = function () {
    window.$('.nav li').removeClass('active').addClass('disabled');
    window.$('#WFarea').html('');
    WB.workflowCtl.reset();
  };
  WB.initUIConfig = function () {
    if (WB.uiConfig && WB.uiConfig.navstyle === 'tabs') WB.enableNavTabs();
  };
}
